import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import { Calendar, Clock, Monitor, Users } from 'lucide-react'
import { batchesAPI } from '@utils/api'

const fallbackBatches = [
  { _id: '1', name: 'DevOps Evening Batch', startDate: new Date().toISOString(), duration: '16 Weeks', mode: 'Online', availableSeats: 12 },
  { _id: '2', name: 'AWS Weekend Batch', startDate: new Date(Date.now() + 86400000 * 7).toISOString(), duration: '12 Weeks', mode: 'Online', availableSeats: 8 },
  { _id: '3', name: 'Kubernetes Fast Track', startDate: new Date(Date.now() + 86400000 * 14).toISOString(), duration: '8 Weeks', mode: 'Hybrid', availableSeats: 6 },
]

const BatchScheduleSection = () => {
  const [batches, setBatches] = useState(fallbackBatches)

  useEffect(() => {
    const load = async () => {
      try {
        const res = await batchesAPI.getUpcoming(6)
        if (res?.data?.length) setBatches(res.data)
      } catch {}
    }
    load()
  }, [])

  return (
    <section className="section-padding bg-white dark:bg-gray-900">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white mb-4">Upcoming Batches</h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">Reserve your seat in the next cohort and start building real-world DevOps skills.</p>
        </div>
        <div className="overflow-x-auto card">
          <table className="min-w-full">
            <thead className="bg-gray-50 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
              <tr>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700 dark:text-gray-300">Batch</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700 dark:text-gray-300">Start Date</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700 dark:text-gray-300">Mode</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700 dark:text-gray-300">Duration</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700 dark:text-gray-300">Seats</th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700 dark:text-gray-300">Action</th>
              </tr>
            </thead>
            <tbody>
              {batches.map((batch, index) => (
                <motion.tr
                  key={batch._id || index}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  className="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800"
                >
                  <td className="px-6 py-4">
                    <div className="font-semibold text-gray-900 dark:text-white">{batch.name}</div>
                  </td>
                  <td className="px-6 py-4 text-gray-600 dark:text-gray-400">{new Date(batch.startDate).toLocaleDateString()}</td>
                  <td className="px-6 py-4">
                    <span className="badge badge-primary">{batch.mode}</span>
                  </td>
                  <td className="px-6 py-4 text-gray-600 dark:text-gray-400">{batch.duration}</td>
                  <td className="px-6 py-4 text-gray-600 dark:text-gray-400">{batch.availableSeats}</td>
                  <td className="px-6 py-4">
                    <a href="/contact" className="btn btn-primary btn-sm">Enroll</a>
                  </td>
                </motion.tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}

export default BatchScheduleSection
